/**
 * 国际化配置文件
 * SC:中文
 * TC:繁体
 */
 export default {
  upperLimitNoIsNull: { SC: "上限不能为空", TC: "上限不能為空", EN: "Upper Limit is required." }
  , download: { SC: "下载中...", TC: "下載中...", EN: "Downloading..." }
  , downloadParam: { SC: "系统参数.xlsx", TC: "系統參數.xlsx", EN: "System Parameters.xlsx" }
  , segmentName: { SC: "参数名称", TC: "參數名稱", EN: "Segment Name" }
  , segmentNameNoIsNull: { SC: "参数名称不能为空", TC: "參數名稱不能為空", EN: "Segment Name is required." }
  , code: { SC: "编码", TC: "編碼", EN: "Code" }
  , codeNoIsNull: { SC: "编码不能为空", TC: "編碼不能為空", EN: "Code is required." }
  , description: { SC: "描述", TC: "描述", EN: "Description" }
  , descriptionNoIsNull: { SC: "描述不能为空", TC: "描述不能為空", EN: "Description is required." }
  , longDesc: { SC: "详细描述", TC: "詳細描述", EN: "Detailed Description" }
  , parmValue1: { SC: "属性1", TC: "屬性1", EN: "Attrib01" }
  , parmValue2: { SC: "属性2", TC: "屬性2", EN: "Attrib02" }
  , parmValue3: { SC: "属性3", TC: "屬性3", EN: "Attrib03" }
  , parmValue4: { SC: "属性4", TC: "屬性4", EN: "Attrib04" }
  , parmValue5: { SC: "属性5", TC: "屬性5", EN: "Attrib05" }
  , parmValue6: { SC: "属性6", TC: "屬性6", EN: "Attrib06" }
  , activeInd: { SC: "是否激活", TC: "是否激活", EN: "Active" }
  , activeIndNoIsNull: { SC: "是否激活不能为空", TC: "是否激活不能為空", EN: "Active is required." }
  , dispSeq: { SC: "序号", TC: "序號", EN: "Seq" }
  , downloadExcel: { SC: "导出Excel表格", TC: "匯出Excel表格", EN: "Download Report" }
  , noIsNull: { SC: "不能为空", TC: "不能為空", EN: " is required." }
  , param: { SC: "系统参数", TC: "系統參數", EN: "System Parameters" }
  , sysManagement: { SC: "系统管理", TC: "系統管理", EN: "System" }
  , selectiveData: { SC: "请选择一条数据", TC: "請選擇一條數據", EN: "Please select a reord." }
  , deleteData: { SC: "数据删除中...", TC: "數據删除中...", EN: "Data is processing..." }
  , deleteSuccess: { SC: "删除成功", TC: "刪除成功", EN: "Deleted successfully." }
  , beQuerying: { SC: "查询中...", TC: "査詢中...", EN: "Searching..." }
  , noneDate: { SC: "找不到符合条件记录.", TC: "找不到符合條件記錄.", EN: "No record is founed." }
  , saveSuccess: { SC: "保存成功", TC: "保存成功", EN: "Saved successfully." }
  , controls: { SC: "操作", TC: "操作", EN: "Operation" }
  , add: { SC: "Add", TC: "Add", EN: "Add" }
  , dataBeSaving: { SC: "数据保存中...", TC: "數據保存中...", EN: "Data is processing..." }
  , sysManage: { SC: "系统管理", TC: "系統管理", EN: "System" }

  , save: { SC: "Save", TC: "Save", EN: "Save" }
  , cancel: { SC: "Cancel", TC: "Cancel", EN: "Cancel" }
  , delete: { SC: "Delete", TC: "Delete", EN: "Delete" }
  , audit: { SC: "Log", TC: "Log", EN: "Log" }
  , list: { SC: "List", TC: "List", EN: "List" }
  , search: { SC: "Search", TC: "Search", EN: "Search" }
  , reset: { SC: "Reset", TC: "Reset", EN: "Reset" }
   // ,studentId: { SC:"Student ID", TC: "Student ID", EN:"Student ID" }
   // ,studentName: {SC:"Student Name", TC: "Student Name" , EN:"Student Name" }
   // ,userAccountManagementStudent: {SC:"User Account Management - Student", TC: "User Account Management - Student" , EN:"User Account Management - Student" }
   ,create: { SC:"Create", TC: "Create", EN:"Create" }
   ,update: { SC: "Edit", TC: "Edit", EN: "Edit" }
   ,batchUpload: { SC: "Batch Upload", TC: "Batch Upload", EN: "Batch Upload" }
   ,saveUpload: { SC: "Save & Upload", TC: "Save & Upload", EN: "Save & Upload" }
   // ,studentSurname: { EN: "Student Surname" }
   // ,studentGivenName: { EN: "Student Given Name" }
   // ,studentEPlatformId: { EN: "Student ePlatform ID" }
   // ,department: { EN: "Department" }
   // ,programme: { EN: "Programme" }
   // ,admissionYear: { EN: "Admission Year" }
   // ,birth: { EN: "Birth" }
   // ,email: { EN: "Email" }
   ,programmeWpaTemplateId:{ SC:"Programme WPA Template ID", TC: "Programme WPA Template ID", EN:"Programme WPA Template ID" }
   ,programmeWpaTemplate:{ SC:"Programme WPA Template", TC: "Programme WPA Template", EN:"Programme WPA Template" }
   ,generalWpaTemplate:{ SC:"Evaluation Survey Template", TC: "Evaluation Survey Template", EN:"Evaluation Survey Template" }
   ,programmeWpaTemplateName:{ SC:"Programme Code", TC: "Programme Code", EN:"Programme Code" }
   ,programme:{ SC:"Programme", TC: "Programme", EN:"Programme" }
   ,lastUpdateDate:{ SC:"Last Update Date", TC: "Last Update Date", EN:"Last Update Date" }
   ,programmeUniqueQuestion1:{SC:"Question 1", TC: "Question 1", EN:"Question 1"}
   ,programmeUniqueQuestion1Weighting:{SC:"Question 1 Weighting", TC: "Question 1 Weighting", EN:"Question 1 Weighting"}
   ,programmeUniqueQuestion2:{SC:"Question 2", TC: "Question 2", EN:"Question 2"}
   ,programmeUniqueQuestion2Weighting:{SC:"Question 2 Weighting", TC: "Question 2 Weighting", EN:"Question 2 Weighting"}
   ,programmeUniqueQuestion3:{SC:"Question 3", TC: "Question 3", EN:"Question 3"}
   ,programmeUniqueQuestion3Weighting:{SC:"Question 3 Weighting", TC: "Question 3 Weighting", EN:"Question 3 Weighting"}
   ,programmeUniqueQuestion4:{SC:"Question 4", TC: "Question 4", EN:"Question 4"}
   ,programmeUniqueQuestion4Weighting:{SC:"Question 4 Weighting", TC: "Question 4 Weighting", EN:"Question 4 Weighting"}
   ,programmeUniqueQuestion5:{SC:"Question 5", TC: "Question 5", EN:"Question 5"}
   ,programmeUniqueQuestion5Weighting:{SC:"Question 5 Weighting", TC: "Question 5 Weighting", EN:"Question 5 Weighting"}
   ,programmeUniqueQuestion6:{SC:"Question 6", TC: "Question 6", EN:"Question 6"}
   ,programmeUniqueQuestion7:{SC:"Question 7", TC: "Question 7", EN:"Question 7"}
   ,programmeUniqueQuestion8:{SC:"Question 8", TC: "Question 8", EN:"Question 8"}


   ,generalWpaQuestion1:{SC:" General WPA Question 1", TC: "General WPA Question 1", EN:"General WPA Question 1"}
   ,generalWpaQuestion1Weighting:{SC:"General WPA Question 1 Weighting", TC: "General WPA Question 1 Weighting", EN:"General WPA Question 1 Weighting"}
   ,generalWpaQuestion2:{SC:" General WPA Question 2", TC: "General WPA Question 2", EN:"General WPA Question 2"}
   ,generalWpaQuestion2Weighting:{SC:"General WPA Question 2 Weighting", TC: "General WPA Question 2 Weighting", EN:"General WPA Question 2 Weighting"}
   ,generalWpaQuestion3:{SC:" General WPA Question 3", TC: "General WPA Question 3", EN:"General WPA Question 3"}
   ,generalWpaQuestion3Weighting:{SC:"General WPA Question 3 Weighting", TC: "General WPA Question 3 Weighting", EN:"General WPA Question 3 Weighting"}
   ,generalWpaQuestion4:{SC:" General WPA Question 4", TC: "General WPA Question 4", EN:"General WPA Question 4"}
   ,generalWpaQuestion4Weighting:{SC:"General WPA Question 4 Weighting", TC: "General WPA Question 4 Weighting", EN:"General WPA Question 4 Weighting"}
   ,generalWpaQuestion5:{SC:" General WPA Question 5", TC: "General WPA Question 5", EN:"General WPA Question 5"}
   ,generalWpaQuestion5Weighting:{SC:"General WPA Question 5 Weighting", TC: "General WPA Question 5 Weighting", EN:"General WPA Question 5 Weighting"}
   ,generalWpaQuestion6:{SC:" General WPA Question 6", TC: "General WPA Question 6", EN:"General WPA Question 6"}
   ,generalWpaQuestion6Weighting:{SC:"General WPA Question 6 Weighting", TC: "General WPA Question 6 Weighting", EN:"General WPA Question 6 Weighting"}
   ,generalWpaQuestion7:{SC:" General WPA Question 7", TC: "General WPA Question 7", EN:"General WPA Question 7"}
   ,generalWpaQuestion7Weighting:{SC:"General WPA Question 7 Weighting", TC: "General WPA Question 7 Weighting", EN:"General WPA Question 7 Weighting"}
   ,generalWpaQuestion8:{SC:" General WPA Question 8", TC: "General WPA Question 8", EN:"General WPA Question 8"}
   ,generalWpaQuestion8Weighting:{SC:"General WPA Question 8 Weighting", TC: "General WPA Question 8 Weighting", EN:"General WPA Question 8 Weighting"}
   ,cohortYear:{ EN: "Cohort" }
   ,status: { EN: "Status" }
   ,cohortYearNoIsNull:{EN:"Cohort is required."}
}